var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.9043,
    cy: 35.474,
    r: 35,
    fill: "#474161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1548 49.2162H24.233V33.3256H29.1548V49.2162ZM29.6459 28.2628C29.6459 26.6717 28.355 25.3802 26.7648 25.3802C25.1685 25.3802 23.8809 26.6717 23.8809 28.2628C23.8809 29.8544 25.1685 31.1459 26.7648 31.1459C28.355 31.1459 29.6459 29.8544 29.6459 28.2628ZM47.5762 40.4738C47.5762 36.2081 46.675 33.0443 41.6919 33.0443C39.2974 33.0443 37.6901 34.2418 37.034 35.4871H37.0293V33.3256H32.248V49.2162H37.0293V41.3264C37.0293 39.2601 37.5553 37.2584 40.1165 37.2584C42.6428 37.2584 42.7246 39.6213 42.7246 41.4576V49.2162H47.5762V40.4738ZM53.9043 51.2552V23.6927C53.9043 21.3664 52.0119 19.474 49.6855 19.474H22.123C19.7967 19.474 17.9043 21.3664 17.9043 23.6927V51.2552C17.9043 53.5816 19.7967 55.474 22.123 55.474H49.6855C52.0119 55.474 53.9043 53.5816 53.9043 51.2552ZM49.6855 22.2865C50.4609 22.2865 51.0918 22.9174 51.0918 23.6927V51.2552C51.0918 52.0306 50.4609 52.6615 49.6855 52.6615H22.123C21.3477 52.6615 20.7168 52.0306 20.7168 51.2552V23.6927C20.7168 22.9174 21.3477 22.2865 22.123 22.2865H49.6855Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.db198c1b.svg";
export { ForwardRef as ReactComponent };